import axios from "axios";
import { BASE_URL } from "../../assets/constants/constants";
import { createHeadersAdmin } from "../../utils/Utils";

//! Admin Login
//  Admin Login
export const adminLoginAPI = async (data,url) => {
  const headers = createHeadersAdmin()   
  return await axios.post(`${BASE_URL()}${url}`, data,headers);
};
export const adminLogoutAPI = async (data,url) => {
  const headers = createHeadersAdmin()
  return await axios.post(`${BASE_URL()}${url}`, data,headers);
};
export const sideBarAPI = async (data) => {
  const headers = createHeadersAdmin()
  return await axios.post(`${BASE_URL()}sidebar`, data,headers);
};